<template>
  <div class="checkbox">
    <input type="checkbox"
      v-model="checked"
      @change="$emit('input', checked)"
    />
    <svg
      :class="{ 'checked-icon--shifted': !checked }"
      class="checked-icon"
      width="16"
      height="14"
      viewBox="0 0 16 14"
    >
      <path d="M2 8.5L6 12.5L14 1.5" />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
  },

  data() {
    return {
      checked: false,
    };
  },

  created() {
    this.checked = this.value
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  background: none;
  position: relative;
  // overflow: hidden;
  user-select: none;
  width: 32px;
  height: 32px;

  input[type='checkbox'] {
    -webkit-appearance: none;
    width: 100%;
    height: 100%;
    margin: 0;
    background: white;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid var(--border-color);
    transition: 0.2s ease-out;

    &:hover {
      border-color: var(--hover-border-color);
    }

    &:checked {
      background: var(--focus-border-color);
    }
  }

  .checked-icon {
    position: absolute;
    left: 25%;
    top: 25%;
    right: 25%;
    bottom: 25%;
    pointer-events: none;
    width: 50%;
    height: 50%;
    fill: none;
    opacity: 1;
    transition: 0.3s ease-out;

    &--shifted {
      opacity: 0;
      top: 50%;
    }

    path {
      stroke: white;
      stroke-width: 2.5;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }
}
</style>